import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-check",
  templateUrl: "./med-icon-check.component.html",
})
export class MedIconCheckComponent extends SvgMixinComponent {}
